import styled, { css } from "styled-components";
import { ISwitchProps } from "@template/components/Switch/index.tsx";
import { ColorKey } from "@template/theme";

export const Wrapper = styled.div<{ $variant: ISwitchProps["variant"] }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: max-content;
  height: max-content;
  align-items: flex-start;
  cursor: pointer;
  ${({ theme, $variant }) => {
    switch ($variant) {
      case "flat":
        return css`
          background: ${theme.colors.default[50]};
          width: 100%;
          height: 100%;
          border-radius: 4px;
          padding: 0 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          min-height: 32px;
          gap: 12px;
        `;
      case "light":
      default:
        return css``;
    }
  }}
`;

export const SwitchContainer = styled.div`
  position: relative;
`;

export const GhostInput = styled.input`
  margin: 0;
  appearance: none;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
`;

export const InputStyle = styled.div<{
  $checked: boolean;
  $disabled?: boolean;
  $color: ColorKey;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 10px;
  background: ${({ theme, $checked, $color }) =>
    theme.colors[$checked ? $color : "default"][200]};

  &::after {
    position: absolute;
    top: 2px;
    height: calc(100% - 4px);
    aspect-ratio: 1;
    display: block;
    content: "";
    border-radius: 50%;
    transition: 0.2s;

    ${({ theme, $checked, $color }) =>
      $checked
        ? css`
            left: 100%;
            background: ${theme.colors[$color].default};
            transform: translateX(calc(-100% - 2px));
          `
        : css`
            left: 2px;
            background: ${theme.colors.default[700]};
          `}
  }

  ${({ theme, $disabled }) =>
    $disabled &&
    css`
      background: ${theme.colors.default[100]};

      &::after {
        background: ${theme.colors.default[300]};
      }
    `}
`;

export const Help = styled.span`
  width: 16px;
  height: 16px;
  display: inline-flex;
  > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.default[400]};
  }
`;
